import { Route } from '@angular/compiler/src/core';
import { Component, OnInit,Output, EventEmitter, ComponentFactoryResolver, ViewChild, ViewContainerRef, } from '@angular/core';
import { Router } from '@angular/router';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelect } from '@angular/material/select';
import { AspMyWishListComponent } from '../asp-my-wish-list/asp-my-wish-list.component';
import { AspMyItemListService } from '../asp-my-item-list/asp-my-item-list.service';

@Component({
  selector: 'app-asp-add-item-sidebar',
  templateUrl: './asp-add-item-sidebar.component.html',
  styleUrls: ['./asp-add-item-sidebar.component.scss']
})
export class AspAddItemSidebarComponent implements OnInit {
  @Output() close = new EventEmitter<void>();
  itemList: any;
  showError: boolean = false;
  isSidebarOpen = false;
  requestPage: string;
  isRequestPopupVisible = false;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';

  selectedKits: any
  popup: boolean;
  activeUrl: string;
  isItemList: boolean;
  need: boolean;
  kits: any;

  constructor(
    private router: Router,
    private resolver: ComponentFactoryResolver,
    private aspMyItemListService:AspMyItemListService,
  ) { }
 @ViewChild('wishlistcontainer', { read: ViewContainerRef }) wishlistcontainer!: ViewContainerRef;
      
  ngOnInit(): void {
    
  this.getKitNames();
    // Load searchItems from localStorage
    this.activeUrl = this.router.url;
    this.isItemList = this.activeUrl.includes('my-item-list');
    const bannerCount = Number(localStorage.getItem('bannerViewCount') || '0');
    if (!this.isItemList && bannerCount < 3) {
    this.popup=true;
     localStorage.setItem('bannerViewCount', String(bannerCount + 1));
    }
    const searchItems = localStorage.getItem('searchItems');
    if (searchItems && searchItems.length > 0) {
      this.itemList = searchItems;
    }
 
  
  }
  getKitNames(){
     this.aspMyItemListService.kitItemNames().subscribe(res =>{
console.log("res",res);
if(res['code']== 200){
let result =JSON.parse(JSON.stringify(res));
this.kits = result.data.kitNames.map((kitName: string) => {
    return {
      name: kitName,
      items: result.data[kitName] || []
    };
  });

  console.log('Updated kits:', this.kits);
     
      
    const normalizedSearchItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)
      .map(item => item.trim().toLowerCase())
      .filter(item => item.length > 0);
     this.selectedKits = this.kits.filter(kit =>
      kit.items.some(kitItem =>
        normalizedSearchItems.includes(kitItem.trim().toLowerCase())
      )
    );
    this.kitItemMap.clear();
    for (let kit of this.selectedKits) {
      this.kitItemMap.set(kit.name, kit.items);
    }
    }
  })
  }

  
  
  submitItems(): void {
    if (!this.itemList) {
      this.showError = true; 
    } else {
      this.showError = false;       
  
      // Format and clean up the item list
      this.itemList = this.formatText(this.itemList);
      console.log("this.itemList", this.itemList);
  
      const itemListArray = this.itemList
        .split(/\s*[,]\s*/)  // Split on commas
        .map(item => item.trim().toLowerCase())
        .filter(item => item.length > 0);

      // 2️⃣ Filter kits that have at least one item present in itemList
      const filteredKits = this.selectedKits.filter(kit => {
        return kit.items.some(kitItem =>
          itemListArray.includes(kitItem.trim().toLowerCase())
        );
      });
  
      // Save the item list and kit names separately in localStorage
      localStorage.setItem('searchItems', this.itemList);   // Save item list
      localStorage.setItem('selectedKits',JSON.stringify(filteredKits));  // Save kit names as an array
  
      this.closeSidebar(); 
  
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/my-item-list']);
      });
    }
  }
  
  
  
  openSidebar() {
    this.isSidebarOpen = true;
  }
  closeSidebar() {
    this.isSidebarOpen = false;
  }

  formatText(text: string): string {
    const items = text
      .split(/[\n,]+/) 
      .map(item => item.trim()) 
      .filter(item => item !== '');
  
    const seen = new Set<string>();
    const uniqueItems = items.filter(item => {
      const lower = item.toLowerCase();
      if (seen.has(lower)) {
        return false;  // Duplicate (case-insensitive)
      }
      seen.add(lower);
      return true;  // First time seen
    });
  
    return uniqueItems.join(', ');
  }
  

 
  
  
 
  
  // Helper map to track items added by each kit
  private kitItemMap: Map<string, string[]> = new Map();
  
  onKitsChanged() {
    // Save current selection into localStorage
    localStorage.setItem('selectedKits', JSON.stringify(this.selectedKits));
  
    // Clear and rebuild kitItemMap
    this.kitItemMap.clear();
    for (let kit of this.selectedKits) {
      this.kitItemMap.set(kit.name, kit.items);
    }
  
    // Combine all kit items and update textarea
    this.updateItemListFromKits();
  
    console.log("selectedKits (after change)", this.selectedKits);
  }
  
  removeKit(kit: any) {
    console.log("kit", kit);
  
    // 1️⃣ Remove kit from selectedKits
    this.selectedKits = this.selectedKits.filter(k => k !== kit);
  
    // 2️⃣ Delete kit from kitItemMap
    this.kitItemMap.delete(kit.name);
  
    // 3️⃣ Remove kit items from itemList
    const kitItemsToRemove = kit.items.map(item => item.trim().toLowerCase());
  
    const currentItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)  // Split by comma OR newline (ignore spaces)
      .map(item => item.trim())
      .filter(item => item.length > 0);
  
    // Remove all kit items (case-insensitive match)
    const updatedItems = currentItems.filter(item => !kitItemsToRemove.includes(item.toLowerCase()));
  
    // 4️⃣ Update itemList
    this.itemList = updatedItems.join(',');
  
    // Optional: Also update the view cleanly (but not strictly needed here)
    this.updateItemListFromKits();
  }
  
  updateItemListFromKits() {
    const toTitleCase = (str: string) =>
      str.split(' ')
         .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
         .join(' ');
  
    const normalize = (str: string) => str.trim().toLowerCase();
  
    // Parse textarea items
    const currentItems = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)
      .map(item => normalize(item))
      .filter(item => item.length > 0);
  
    // Get all selected kit items (flattened and normalized)
    const selectedKitItems = ([] as string[]).concat(...Array.from(this.kitItemMap.values()))
      .map(item => normalize(item));
  
    // Keep manually typed items that are not from kits, or still match selected kits
    const finalItems = currentItems.filter(item =>
      selectedKitItems.includes(item) || !this.isItemFromAnyKit(item)
    );
  
    // Merge and remove duplicates
    const merged = Array.from(new Set([...finalItems, ...selectedKitItems]));
  
    // Format (title-case) and output
    this.itemList = merged
      .map(toTitleCase)
      .join('\n'); // If you don’t want sorted order, remove `.sort(...)`
  }
  
  
  // Utility: Check if item belongs to any defined kit
  isItemFromAnyKit(item: string): boolean {
    return this.kits.some(kit =>
      kit.items.some(kitItem => kitItem.trim().toLowerCase() === item)
    );
  }
  
  onItemListChanged() {
    // Normalize current itemList into lowercase array (support comma or newline)
    const itemListArray = (this.itemList ?? '')
      .split(/\s*[\n,]\s*/)   // Support comma **or** newline
      .map(item => item.trim().toLowerCase())
      .filter(item => item.length > 0);
  
    // If text area is completely empty, don't clear all kits aggressively
    if (itemListArray.length === 0) {
      return; // Do nothing for now
    }
  
    // Only remove kits whose ALL items are missing from textarea
    const stillSelectedKits = this.selectedKits.filter(kit => {
      const hasAtLeastOneItem = kit.items.some(kitItem =>
        itemListArray.includes(kitItem.trim().toLowerCase())
      );
      return hasAtLeastOneItem;
    });
  
    if (stillSelectedKits.length !== this.selectedKits.length) {
      this.selectedKits = stillSelectedKits;
  
      // Rebuild kitItemMap cleanly
      this.kitItemMap.clear();
      for (let kit of this.selectedKits) {
        this.kitItemMap.set(kit.name, kit.items);
      }
    }
  }
  closeSelectPanel(select: MatSelect) {
    select.close();
  }
  closePopup(){
    this.popup=false;
    this.need=false;
  }
  needHelp(){
    this.popup=true;
    this.need=true;
  }
  wishlistItems(){
    sessionStorage.removeItem('wishlist');
   
    if (!this.itemList) {
      this.showError = true; 
    } else {
      
    localStorage.setItem("addAllItem",'true')
       this.isSidebarOpen = false;
      this.showError = false;       
  
      // Format and clean up the item list
      this.itemList = this.formatText(this.itemList);
      console.log("this.itemList", this.itemList);
  
      const itemListArray = this.itemList
        .split(/\s*[,]\s*/)  // Split on commas
        .map(item => item.trim().toLowerCase())
        .filter(item => item.length > 0);

      // 2️⃣ Filter kits that have at least one item present in itemList
      const filteredKits = this.selectedKits.filter(kit => {
        return kit.items.some(kitItem =>
          itemListArray.includes(kitItem.trim().toLowerCase())
        );
      });
  
      // Save the item list and kit names separately in localStorage
      localStorage.setItem('searchItems', this.itemList);   // Save item list
      localStorage.setItem('selectedKits',JSON.stringify(filteredKits));  // Save kit names as an array
      let wishlist: { name: string, quantity: number }[] = JSON.parse(sessionStorage.getItem('wishlist') || '[]');
      console.log("this.itemList", this.itemList);
 const itemList = this.itemList.split(','); // split by comma

for (let item of itemList) {
  const trimmed = item.trim();
  if (trimmed) {
    const name = trimmed
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');

    wishlist.push({ name, quantity: 1 });
  }
}
       sessionStorage.setItem('wishlist',JSON.stringify(wishlist));
    const factory = this.resolver.resolveComponentFactory(AspMyWishListComponent);
    const componentRef = this.wishlistcontainer.createComponent(factory);

    // Access the instance and call the method
    const componentBInstance = componentRef.instance as AspMyWishListComponent;
    componentBInstance.closeSidebar(true);
  }
}
}
